export default "<p>faq works!</p>\r\n"